import { render, staticRenderFns } from "./ActivityWrap.vue?vue&type=template&id=40f97a3a&scoped=true"
import script from "./ActivityWrap.vue?vue&type=script&lang=js"
export * from "./ActivityWrap.vue?vue&type=script&lang=js"
import style0 from "./ActivityWrap.vue?vue&type=style&index=0&id=40f97a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f97a3a",
  null
  
)

export default component.exports